export enum AppLanguage {
  English = 'en',
  Czech = 'cs',
}

export const appDefaultLanguage = AppLanguage.Czech;
